export default __webpack_public_path__ + "static/media/docker.e0ba9d23.png";